import { Fragment, useEffect, useState, useRef, useContext } from "react";
import BoxTitle from "../../box/title/BoxTitle";
import BoxSubTitle from "../../box/subTitle/BoxSubTitle";
import BoxEntity from "../../box/entity/BoxEntity";
import CustomSlider from "../../customSlider/CustomSlider";

import { useTranslation } from "react-i18next";
import { MeshDataContext } from "../../../hooks/context";
import { LoadingDot } from "../../UI/spinners/LoadingSpinners";

const meshliumId = "2";
const Meshlium = ({
  previewIndex,
  maxEntities,
  previewGroup,
  typeId,
  type,
}) => {
  const { MeshData, loading } = useContext(MeshDataContext);

  const subTitleRef = useRef(null);

  const { t } = useTranslation();

  return (
    <Fragment>
      <BoxTitle
        icon="im im-icon-Business-Mens"
        title={t("mesh.title")}
        link={`/map?typeId=${typeId}`}
        id={meshliumId}
        infoContext={t(`${type}.tooltip`)}
        element={
          <i
            id="draggable"
            className="im im-icon-Double-Tap"
            style={{ fontSize: "32px", minWidth: "32px", cursor: "pointer" }}
          />
        }
      />
      {subTitleRef.current && (
        <p style={{ textAlign: "center", margin: "10px 0 5px" }}>
          <strong>{subTitleRef.current}</strong>
        </p>
      )}
      {!loading && MeshData && (
        <CustomSlider>
          <div key={`mesh_data_${previewIndex}`}>
            <BoxSubTitle style={{ fontWeight: "600" }}>
              {t(
                `environmental.areaNames.${MeshData[previewIndex].mysensor_name}`,
              )}
            </BoxSubTitle>
            {MeshData[previewIndex].details.map((item, id) => {
              return (
                <BoxEntity
                  key={`${MeshData[previewIndex].mysensor_name}_${id}`}
                  icon={`https://smartcity.patras.gr/gallery/vars/Small/${item.sensorvar_icon}`}
                  content={t(`mesh.${item.sensorvar_description}`)}
                  value={[item.wfTotal ?? item.btTotal]}
                />
              );
            })}
          </div>
        </CustomSlider>
      )}

      {loading && <LoadingDot />}
    </Fragment>
  );
};

export default Meshlium;
